import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { LanguageService } from '../../../../../services/languageService';
import { SystemSettingsService } from '../../../../../services/systemSettingsService';
import { useState } from 'react';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import PersonRemoveAlt1OutlinedIcon from '@mui/icons-material/PersonRemoveAlt1Outlined';
import TextSnippetOutlinedIcon from '@mui/icons-material/TextSnippetOutlined';
import { AppRoutes } from '../../../../../constants/appRoutes';
import { IS_SA } from '../../../../../config/appConfig';
import { buildLocalizeRoute } from '../../../../../helpers/languageHelper';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import { Box } from '@mui/material';
import { SectionWithHeading } from '../../../../../shared/components/common/sectionWithHeading';
import { Section } from '../../../../../shared/components/common/section';
import { ButtonWrapper } from '../../../../../shared/components/formUtilities/useButton';
import { ArrowIcons } from '../../../../../shared/components/common/arrowIcons';
import { RegionService } from '../../../../../services/regionService';

export const BorrowerProfileSections = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const languageService = new LanguageService();
	const regionService = new RegionService();
	const systemSettingsService = new SystemSettingsService();
	const [isExpand, setIsExpand] = useState(false);
	const location = useLocation();
	const sections = [
		{
			mainSection: 'myProfile',
			subSection: [
				{
					name: 'updateDetails',
					icon: <EditOutlinedIcon />,
					linkTo: `${AppRoutes.Borrower}/${AppRoutes.Profile}/${AppRoutes.IProfileUpdate}`,
				},
			],
		},
		{
			mainSection: 'security',
			subSection: [
				{
					name: 'resetPassword',
					icon: <LockOutlinedIcon />,
					linkTo: `${AppRoutes.Borrower}/${AppRoutes.Profile}/${AppRoutes.IChangePassword}`,
				},
				{
					hide: IS_SA,
					name: 'deactivateAccount',
					icon: <PersonRemoveAlt1OutlinedIcon className="!text-red-600" />,
					linkTo: `${AppRoutes.Borrower}/${AppRoutes.Profile}/${AppRoutes.IDeactivateAccount}`,
				},
			],
		},
		{
			mainSection: 'agreements',
			subSection: [
				{
					name: 'termsConditionsBorrower',
					icon: <TextSnippetOutlinedIcon />,
					externalLink: true,
					onClick: () => {
						openUrl();
					},
					linkTo: '',
				},
			],
		},
	];

	const settings = () => {
		return systemSettingsService.systemSettings();
	};

	const isAr = () => {
		return languageService.isArabic();
	};

	const isActiveSection = (subSection) => {
		return (
			location.pathname ===
			`/${regionService.currentRegion()}/${languageService.getCurrentLanguage()}/${subSection?.linkTo}`
		);
	};

	const openUrl = () => {
		window.open(settings()?.investorTermsAndConditions, '_blank');
	};

	const openLink = (link) => {
		setIsExpand(!isExpand);
		if (link) {
			navigate(buildLocalizeRoute(link));
		}
	};

	return (
		<Box className="flex items-start md:flex-row flex-col">
			<SectionWithHeading
				bodyClass={'!p-0'}
				actionButtons={
					<Box
						className="md:!hidden !flex cursor-pointer"
						onClick={() => {
							setIsExpand(!isExpand);
						}}>
						{isExpand ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
					</Box>
				}
				heading={
					<Box
						className="flex justify-center items-center md:pointer-events-none"
						onClick={() => {
							setIsExpand(!isExpand);
						}}>
						<Box className="flex items-center">
							<ManageAccountsOutlinedIcon
								className="!text-[26px]"
								color="primary"></ManageAccountsOutlinedIcon>
							<span className="mx-2">{t('profileAndSettings')}</span>
						</Box>
					</Box>
				}
				classList={`md:!w-[320px] !w-full !mb-4 ${isAr() ? 'md:!ml-4' : 'md:!mr-4'
					}`}
				children={
					<Box
						className={`flex flex-col profile-wrapper md:!max-h-[740px] ${!isExpand ? 'expand-profile' : ''
							}`}>
						{sections.map((section, index) => {
							return (
								<Box
									key={index}
									className="flex flex-col space-y-2 !p-4">
									<Box className="font-[600] text-[15px]">
										{t(section.mainSection)}
									</Box>
									{section.subSection.map((subSec, index) => {
										return (
											<>
												{!subSec?.hide ? (
													<Section
														isShadow={false}
														classList={`!cursor-pointer !p-2 profile-section ${isActiveSection(subSec)
																? 'active-profile-section'
																: ''
															}`}
														onClick={() =>
															subSec?.onClick
																? subSec?.onClick()
																: openLink(subSec?.linkTo)
														}
														key={subSec?.name}
														children={
															<Box className="flex justify-between items-center">
																<Box className="flex items-center">
																	<ButtonWrapper
																		classList="!icon-bg-color !text-primary"
																		icon={subSec.icon}
																		iconButton></ButtonWrapper>
																	<Box className="font-[500] text-sm mx-2">
																		{t(subSec?.name)}
																	</Box>
																</Box>
																<Box>
																	<ArrowIcons
																		isKeyboardArrow
																		classList={'!text-primary'}></ArrowIcons>
																</Box>
															</Box>
														}></Section>
												) : null}
											</>
										);
									})}
								</Box>
							);
						})}
					</Box>
				}></SectionWithHeading>
			<Box className="md:!w-[calc(100%-335px)] !w-full">
				<Outlet></Outlet>
			</Box>
		</Box>
	);
};
